import { useTheme } from 'next-themes';
import { memo } from 'react';

import { PaletteIcon } from '@air/design-icons';
import { DropdownMenuRadioGroup, DropdownMenuRadioItem, DropdownMenuSub } from '@air/primitive-dropdown-menu';

export const WorkspaceHeaderInformationDropdownThemeItems = memo(() => {
  const { theme, setTheme } = useTheme();

  return (
    <DropdownMenuSub
      label="Color theme"
      prefix={<PaletteIcon aria-hidden className="ads:text-icon-subtle text-gray-9" size="sm" />}
      size="small"
    >
      <DropdownMenuRadioGroup value={theme} onValueChange={setTheme}>
        <DropdownMenuRadioItem label="Light" size="small" value="light" />
        <DropdownMenuRadioItem label="Dark" size="small" value="dark" />
        <DropdownMenuRadioItem label="System" size="small" value="system" />
      </DropdownMenuRadioGroup>
    </DropdownMenuSub>
  );
});

WorkspaceHeaderInformationDropdownThemeItems.displayName = 'WorkspaceHeaderInformationDropdownThemeItems';
